export const ACCOUNT_ID_FIELDS = ['CreatedById', 'LastModifiedById', 'OwnerId'];
export const ACCOUNT_DATE_FIELDS = ['CreatedDate', 'LastModifiedDate', 'SystemModstamp'];
